module.exports = __webpack_public_path__ + "img/people12.f8f9a1de.png";